import { fromJS } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { getFilterRulesByThreadId as requestFn } from '../clients/getFilterRulesByThreadId';
import { FETCH_FILTER_RULES_BY_THREAD_ID as actionTypes } from '../constants/asyncActionTypes';
export const fetchFilterRulesByThreadId = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: fromJS
});